<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-7 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeIds"
              :options="officeDropdown"
              :is-clear="true"
              :is-multi="true"
              :placeholder="$t('placeholder.office_name')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
<!--        <div v-if="operationTypeDropdown && operationTypeDropdown.length">-->
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="true"
              placeholder="Maßeinheitentyp"
          />
<!--        </div>-->
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);
const {filters} = toRefs(props);
const operationTypeDropdown = toRefs(props)['operationTypeDropdown'];
const officeDropdown = toRefs(props)['officeDropdown'];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
